module.exports = __webpack_public_path__ + "cement/img/科技 (1)@2x.01f8ed07.png";